import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Controller, useForm } from "react-hook-form";
import { useFetch } from "../../hooks/useFetch";
import { bookEpuja, getAllCities } from "../../apis";
import RazorPay from "../../components/RazorPay";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import Loader from "../../components/elements/Loader";


export default ({ details = {} }) => {
    const params = useParams()

    const { register, handleSubmit, control, getValues, watch, reset  } = useForm({ onChange: true })
    const [cities] = useFetch(getAllCities, [])
    const { customer, isLoggedIn } = useSelector( state => state.auth )
    
    const [loading, setLoading] = useState(false);
    const [ razorpay, setRazorpay ] = useState({ amountToPay: 0, bookingId: null, orderId: null, open: false })

    useEffect(() => {
        if( isLoggedIn ){
            reset({
                firstName: customer.firstName,
                lastName: customer.lastName,
            })
        }
    }, [ isLoggedIn ])



    const submit = async ( data ) => {
        try {
            setLoading(true)
            data.ePujaId = params.pujaId
            data.price = details.price
            // data.date = data.date?.toLocaleDateString()
            const response = await bookEpuja( data )

            setRazorpay({ 
                amountToPay: response.amountToPay,
                bookingId: response.bookingId,
                orderId: response.razorpayOrderId
            })
            
        } catch (error) {
            console.log("error", error)
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            <Loader loading={loading} />
            <form onSubmit={handleSubmit(submit)} className="card rounded-4 p-4  m-2">
                <div className="row">
                    <div className="col-6 p-0">
                        <div className="m-2">
                            <label className="mb-1 bold" >First Name</label>
                            <input
                                className="input-2"
                                placeholder="Enter First Name"
                                { ...register("firstName", { required: true })}
                            />
                        </div>
                    </div>
                    <div className="col-6 p-0">
                        <div className="m-2">
                            <label className="mb-1 bold">Last Name</label>
                            <input
                                className="input-2"
                                placeholder="Enter Last Name"
                                { ...register("lastName", { required: true })}
                            />
                        </div>
                    </div>

                    <div className="col-12 p-0">
                        <div className="m-2">
                            <label className="mb-1 bold">Gotra</label>
                            <input
                                className="input-2"
                                placeholder="Person's Gotra"
                                { ...register("gotra", { required: false })}
                            />
                        </div>
                    </div>

                    <div className="col-12 p-0">
                        <div className="m-2">
                            <label className="mb-1 bold">Note</label>
                            <input className="input-2" placeholder="Write Note" { ...register("note", { required: false })} />
                        </div>
                    </div>

                    <div className="col-6 p-0">
                        <div className="m-2">
                            <label className="mb-1 bold">Date</label>
                            <Controller
                                name="bookingDate"
                                control={control}
                                rules={{ required: true }}
                                render={({ field }) =>
                                    <DatePicker
                                        {...field}
                                        selected={getValues("bookingDate")}
                                        placeholderText="Date"
                                        className="input-2"
                                        minDate={new Date()}
                                    />
                                }

                            />
                        </div>
                    </div>

                    <div className="col-6 p-0">
                        <div className="m-2">
                            <label className="mb-1 bold">City</label>
                            <select
                                type="date"
                                className="input-2"
                                placeholder="Write Note"
                                {...register("cityId", { required: true })}
                            >
                                <option>Select Location</option>
                                {cities?.map((city, i) => <option key={i} value={city._id || city.id}>{city.name}</option>)}
                            </select>
                        </div>
                    </div>

                    <div className="col-6">
                        <p className="bold fs-5">Price</p>
                    </div>
                    <div className="col-6">
                        <p className="bold fs-5 text-saffron text-end">₹{ details.price }</p>
                    </div>
                </div>
                <button className="primary-btn my-3">Book Now</button>
            </form>

            <RazorPay amount={razorpay.amountToPay} bookingId={razorpay.bookingId} orderId={razorpay.orderId} customer={customer} cb={(type, response) =>  setRazorpay({}) } />
        </>
    )
}